import { BasicResult } from "../basic-result";

export class ExportJobResult extends BasicResult {
    public JobID: string = "";
    public Status: string = "";
    public Progress: number = 0;
    public FileName: string = "";
    public IsComplete: boolean = false;

    constructor(values: Object = {}) {
        super(values);
        Object.assign(this, values);
    }
}
